import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="644.8"
      height="1173.041"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 644.8 1173.041"
      xmlSpace="preserve"
      className='clickable'
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        fill='rgba(0,0,0,0)'
        className='object-glow'
        stroke="#ff5c97"
        strokeLinejoin="round"
        clipPath="url(#ArtboardFrame)"
        transform="translate(-104.559 -986.959)"
      >
        <path
          fill="none"
          strokeLinecap="butt"
          strokeWidth="5"
          d="M495.559 989.859c-6.067.934-10.5 2.334-13.3 4.2-2.8 1.867-6.3 2.567-10.5 2.1-4.2-.466-7 .234-8.4 2.1-1.4 1.871-7.934 4.431-19.6 7.701-11.667 3.27-23.8 9.33-36.4 18.2-12.6 8.87-21.934 17.97-28 27.3-6.067 9.33-10.734 22.63-14 39.9-3.267 17.27-5.367 31.5-6.3 42.7-.934 11.2-1.634 22.87-2.1 35-.467 12.13 0 23.1 1.4 32.9 1.4 9.8 4.2 21 8.4 33.6 4.2 12.6 9.1 22.17 14.7 28.7 5.6 6.53 10.5 10.97 14.7 13.3 4.2 2.33 6.533 5.83 7 10.5.466 4.67 2.1 10.73 4.9 18.2 2.8 7.47-1.167 16.1-11.9 25.9a171.45 171.45 0 00-28 32.9c-7.934 12.13-17.967 25.9-30.1 41.3-12.134 15.4-20.067 26.6-23.8 33.6-3.734 7-8.634 13.53-14.7 19.6-6.067 6.07-10.734 12.13-14 18.2-3.267 6.07-9.567 12.37-18.9 18.9-9.334 6.53-15.167 11.67-17.5 15.4-2.334 3.73-4.2 8.17-5.6 13.3-1.4 5.13-3.967 10.27-7.7 15.4-3.734 5.13-8.867 10.73-15.4 16.8-6.534 6.07-11.9 10.03-16.1 11.9-4.2 1.87-7 4.67-8.4 8.4-1.4 3.73-11.097 11.97-22.122 30.34-11.025 18.38-17.312 32.19-21.978 43.16-9.334 21.93-16.567 44.8-21.7 68.6-5.134 23.8-10.267 43.63-15.4 59.5-5.134 15.87-7.7 28-7.7 36.4 0 8.4 2.333 15.4 7 21 4.666 5.6 9.333 13.53 14 23.8 4.666 10.27 8.166 16.33 10.5 18.2 2.333 1.87 7 2.1 14 .7 7-1.4 12.6-5.13 16.8-11.2 4.2-6.07 7-16.1 8.4-30.1 1.4-14 3.733-24.03 7-30.1 3.266-6.07 6.066-14.23 8.4-24.5 1.166-5.13 2.333-10.27 3.5-15.4.933.23 1.866.47 2.8.7 1.866.47 2.333 6.77 1.4 18.9-.934 12.13-.467 19.13 1.4 21 1.866 1.87 3.5 4.9 4.9 9.1 1.4 4.2 3.5 6.53 6.3 7 2.8.47 4.666 0 5.6-1.4.933-1.4 1.866-13.77 2.8-37.1.933-23.33-.234-42.7-3.5-58.1-3.267-15.4-4.434-26.37-3.5-32.9.933-6.53 2.8-11.2 5.6-14 2.8-2.8 7.7-6.07 14.7-9.8 7-3.73 14.466-10.5 22.4-20.3 7.933-9.8 13.066-14.7 15.4-14.7 2.333 0 5.833-1.17 10.5-3.5 4.666-2.33 12.833-9.57 24.5-21.7 11.666-12.13 18.2-18.2 19.6-18.2 1.4 0 3.033 4.67 4.9 14 1.866 9.33 2.8 18.67 2.8 28 0 9.33-1.4 20.07-4.2 32.2-2.8 12.13-4.434 23.8-4.9 35-.467 11.2-1.867 21.23-4.2 30.1-2.334 8.87-3.734 16.8-4.2 23.8-.467 7 .7 14.7 3.5 23.1 2.8 8.4 8.4 16.8 16.8 25.2 8.4 8.4 13.533 15.87 15.4 22.4 1.866 6.53 2.8 17.73 2.8 33.6 0 15.87-.7 30.8-2.1 44.8-1.4 14-1.867 32.9-1.4 56.7.466 23.8-.234 44.57-2.1 62.3-1.867 17.73-7.7 44.57-17.5 80.5s-18.2 75.6-18.2 75.6l352.1-9.1s7.466-47.13 19.6-79.8c12.133-32.67 18.2-54.6 18.2-65.8 0-11.2-1.167-23.8-3.5-37.8-2.334-14-5.134-27.77-8.4-41.3-3.267-13.53-8.167-29.63-14.7-48.3-6.534-18.67-5.367-35.23 3.5-49.7 8.866-14.47 14.7-26.37 17.5-35.7 2.8-9.33 4.666-18.43 5.6-27.3.933-8.87 3.266-16.57 7-23.1 3.733-6.53 6.533-13.77 8.4-21.7 1.866-7.93 2.566-15.4 2.1-22.4-.467-7-.234-11.9.7-14.7.933-2.8.466-7-1.4-12.6-1.867-5.6-1.867-11.2 0-16.8 1.866-5.6 2.566-17.73 2.1-36.4-.467-18.67 0-37.57 1.4-56.7 1.4-19.13 3.033-35.23 4.9-48.3 1.866-13.07 5.133-26.13 9.8-39.2 4.666-13.07 7-22.87 7-29.4 0-6.53-2.8-18.9-8.4-37.1-5.6-18.2-10.967-31.97-16.1-41.3-5.134-9.33-8.167-14-9.1-14-.934 0-1.634-1.4-2.1-4.2-.467-2.8-1.867-5.37-4.2-7.7-2.334-2.33-3.734-6.3-4.2-11.9-.467-5.6-3.967-15.17-10.5-28.7-6.534-13.53-11.2-26.13-14-37.8-2.8-11.67-5.134-18.9-7-21.7-1.867-2.8-3.5-9.8-4.9-21-1.4-11.2-4.2-22.87-8.4-35-4.2-12.13-9.1-29.4-14.7-51.8s-10.734-40.37-15.4-53.9c-4.667-13.53-9.1-24.5-13.3-32.9-4.2-8.4-9.567-17.03-16.1-25.9-6.534-8.87-14-17.03-22.4-24.5-8.4-7.47-15.4-12.37-21-14.7-5.6-2.334-11.667-3.734-18.2-4.201-6.534-.466-13.534-1.866-21-4.2-7.467-2.333-14.234-3.033-20.3-2.1z"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M198.928 1578.22c7.979-10.13 20.893-5.57 29.989-.24 17.49 10.25 44.655 36.32 42.219 57.32"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M328.117 1593.36c-4.169-16.47 3.458-39.24 11.914-73.64 8.457-34.4 25.509-68.12 25.509-68.12"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M677.282 1856.31s-25.225 37.22-55.07 71.33-64.31 65.11-64.31 65.11"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M629.34 1743.11s2.032 6.64-15.478 47.41c-17.509 40.77-66.278 118.07-66.278 118.07"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M713.657 1759.13c2.36-15.51-29.699-25.29-48.213-27.08-18.762-1.82-33.188-1.99-44.715 7.18-4.562 3.63-5.246 6.82-4.866 8.52.907 4.07 4.413 6.11 8.115 7.26"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="5"
          d="M385.043 1050.71c1.098 4.69 9.478 9.85 12.945 14.02 6.763 8.13 11.314 18.56 15.686 28.16 9.236 20.27 13.447 42.61 22.683 62.89 4.411 9.69 13.24 20.32 20.788 28.1 5.57 5.74 9.84 13.88 14.458 20.49 5.948 8.5 15.209 16.08 22.599 23.69 14.365 14.8 26.015 35.03 43.742 46.03 31.257 19.4 67.184 25.73 101.008 40.57 11.544 5.07 20.892 14.97 31.919 19.81 4.177 1.84 9.768 2.38 13.62 4.77 5.783 3.59 10.621 11.94 17.382 13.55"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M464.28 1302.81c-1.817 3.63-1.305 8.95-2.843 12.79-6.685 16.71-16.661 31.28-25.877 46.64-4.993 8.32-16.229 14.62-17.915 24.74-3.283 19.7 9.983 18.71 18.768 30.42 2.612 3.49.893 9.87 1.706 13.94.601 3 2.333 5.75 2.844 8.81 1.53 9.18-5.441 24.55-8.815 32.99-3.213 8.03-4.28 17.42-5.972 25.87-.368 1.85-1.931 3.36-3.128 4.55-4.335 4.34-8.75 14.38-11.374 19.62"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M433.001 1483.37c1.604-4.81 7.243-8.91 8.246-13.93 2.159-10.8 8.372-20.82 10.521-31.56 2.859-14.3 6.933-27.35 15.64-38.96 8.428-11.24 25.567-4.24 34.408-13.08 6.025-6.03 2.984-16.35 9.099-22.47 8.494-8.49 19.591-14.75 28.152-23.31 9.886-9.89 18.562-20.68 26.73-31.57 3.41-4.54 8.196-7.29 10.805-12.51"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M520.015 1358.54c4.263 0 4.999 9.69 5.403 12.51 2.069 14.49-.851 28.15-5.972 41.8-.717 1.92-9.873 21.54-4.55 20.48 10.41-2.08 12.394-8.37 20.19-14.22 14.46-10.85 21.074-27.83 30.142-42.94 4.592-7.65 4.98-22.4 8.531-31.28 4.363-10.91 13.45-16.81 20.474-25.59 3.001-3.75 5.842-9.9 10.237-11.66.838-.33.533-1.78 1.137-.57"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M428.735 1496.74c13.656 0 21.259-11.81 26.73-22.75"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M459.446 1466.31c7.092-10.63 11.769-23.25 17.346-34.4.904-1.81 6.992-17.87 7.962-15.93"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M706.588 1366.17c-21.882-17.04-65.359-10.13-75.767 18.05-18.559 50.26-35.023 40.4-27.39 127.33l6.802 54.81"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M464.967 1304.94c0 26.82 1.241 52.6-5.302 78.77-2.093 8.37-3.499 16.6-4.039 25.24-.146 2.34 0 4.73 0 7.07v2.78"
          opacity="1"
        ></path>
        <path
          fill="#000"
          fillOpacity="0.95"
          fillRule="nonzero"
          strokeLinecap="butt"
          strokeWidth="1"
          d="M426.081 1388.28c0-2.36 1.915-4.28 4.278-4.28a4.281 4.281 0 010 8.56 4.281 4.281 0 01-4.278-4.28z"
          opacity="1"
        ></path>
        <path
          fill="#000"
          fillOpacity="0.95"
          fillRule="nonzero"
          strokeLinecap="butt"
          strokeWidth="1"
          d="M452.175 1453.47a4.268 4.268 0 118.535 0c0 2.35-1.911 4.26-4.267 4.26a4.266 4.266 0 01-4.268-4.26z"
          opacity="1"
        ></path>
        <path
          fill="#000"
          fillOpacity="0.95"
          fillRule="nonzero"
          strokeLinecap="butt"
          strokeWidth="1"
          d="M469.322 1407.41a4.268 4.268 0 118.535 0 4.268 4.268 0 11-8.535 0z"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1"
          d="M431.777 1839c-.358 4.27 3.819 6.66 6.242 9.08 5.803 5.81 12.743 9.18 21.664 7.96 17.023-2.31 34.62-1.14 51.612-2.13 14.774-.86 29.219-5.55 43.565-6.38"
          opacity="1"
        ></path>
        <path
          fill="#000"
          fillOpacity="0.95"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeWidth="1"
          d="M549.837 1853.93c0-2.22 1.802-4.02 4.025-4.02a4.025 4.025 0 11-4.025 4.02z"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeDasharray="2"
          strokeLinecap="round"
          strokeWidth="1"
          d="M631.747 1921.14l16.077 95.7s29.752 29.28 43.637 33.17c6.38 1.79 10.405-10.91 10.405-10.91"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeDasharray="2"
          strokeLinecap="round"
          strokeWidth="1"
          d="M634.81 1915.27l17.059 98.03s26.927 23.88 40.812 27.77c6.38 1.79 9.791-9.44 9.791-9.44"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;